<template>
<div>
  <Grid name="generalFilter" ref="generalFilter" v-bind:url="url" v-bind:columns="columns" :pageable='true' :height="height" :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields" v-bind:preload="preload"   v-bind:databound="dataBound"></Grid>
  <div>
    <b-button v-on:click="addAll()" variant="success">Incluir todos</b-button>
    <b-button variant="danger" v-on:click="excludeAll()">Excluir todos</b-button>
  </div>
</div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import BaseFilter from './BaseFilter'
export default {
  name: 'GeneralFilter',
  extends: BaseFilter,
  props: ['height', 'filters', 'field', 'url', 'name'],
  components: {
    Grid
  },
  data() {
    return {
      fieldName: '',
      fieldLabel: '',
      gridRef: 'generalFilter',
      preload: [],
      schemaModelFields: {},
      columns: [{
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-success',
          text: 'incluir',
          click: this.addIncludeFilter
        }
      }, {
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-danger',
          text: 'excluir',
          click: this.addExcludeFilter
        }
      }, {
        width: '160px',
        field: 'code',
        title: 'Código'
      }, {
        field: 'name',
        title: 'Name'
      }, {
        field: 'id',
        title: 'ID'
      }],
      loaded: false,
      tableInitialized: false
    }
  },
  created() {
    this.fieldName = this.field
    this.fieldLabel = this.name
  }
}
</script>



// WEBPACK FOOTER //
// Filter.vue?488a5d2e